<div [class]="class">

    <ng-template #buttonContent>
        <span class="indicator__area">
            <app-icon [class]="iconClass" *ngIf="icon" [ngClass]="{'indicator__icon': iconWhenOpen}" [name]="icon"
                [size]="size"></app-icon>
            <img *ngIf="image" [src]="image" width="20" [class]="imageClass">
            <app-icon *ngIf="iconWhenOpen" class="indicator__icon indicator__icon--open {{iconClass}}" [name]="iconWhenOpen"
                size="20"></app-icon>
            <mat-icon [class]="iconClass" *ngIf="matIcon" [fontIcon]="matIcon"></mat-icon>
            <mat-icon [class]="iconClass" *ngIf="svgIcon" [fontSet]="fontSet" [svgIcon]="svgIcon"></mat-icon>

            <span *ngIf="counter !== null" class="indicator__value">{{ counter }}</span>
        </span>
    </ng-template>

    <button *ngIf="link === null" type="button" class="indicator__button" (click)="onClick($event)">
        <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
    </button>

    <a *ngIf="link !== null && trigger === 'click'" [href]="link" class="indicator__button" (click)="onClick($event)"
        (appTouchClick)="onTouchClick($event)">
        <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
    </a>

    <a *ngIf="link !== null && trigger !== 'click'" [routerLink]="link" class="indicator__button"
        (click)="onClick($event)" (appTouchClick)="onTouchClick($event)">
        <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
    </a>

    <div class="indicator__dropdown" #dropdownElement>
        <ng-content></ng-content>
    </div>
</div>